import React, { ReactNode } from 'react';
import { useAuth } from '@/app/providers/AuthProvider';
import { usePlanModal } from '@/app/contexts/PlanModalContext';

interface RestrictedFeatureProps {
  permission: string;
  children: ReactNode;
  className?: string;
  as?: 'div' | 'span';
}

export function RestrictedFeature({ permission, children, className = '', as = 'div' }: RestrictedFeatureProps) {
  // Pass-through: All features are now unlocked because the entire app is plan-gated.
  // We keep this component to avoid breaking imports and layout structure.
  return <>{children}</>;
}
